import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../reducers';

export const getProgressState = createSelector(getDragonflySharedState, (state) => state.progress);

export const getProgressSpinner = createSelector(
  getProgressState,
  ({ showSpinner }) => showSpinner,
);

export const getProgressBar = createSelector(
  getProgressState,
  getProgressSpinner,
  ({ showBar }, showSpinner) => showBar && !showSpinner,
);

export const getProgressSearchSpinner = createSelector(
  getProgressState,
  ({ showSearchSpinner }) => showSearchSpinner,
);

export const getTotalLoadRequests = createSelector(
  getProgressState,
  ({ totalLoadRequests }) => totalLoadRequests,
);

export const getTotalActionRequests = createSelector(
  getProgressState,
  ({ totalActionRequests }) => totalActionRequests,
);

export const getTotalSearchRequests = createSelector(
  getProgressState,
  ({ totalSearchRequests }) => totalSearchRequests,
);
